"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = compose;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
/*
This was copied from the redux library. It lets us clean up multiple HOCs.

like:

export default compose(
    withNuiIntl,
    withStylesLoaded,
)(AppHeader);

instead of:

export default withNuiIntl(withStylesLoaded(AppHeader))
*/
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return (0, _reduce["default"])(funcs).call(funcs, function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}